import { error } from '@sveltejs/kit';

import type { PageLoadEvent } from './$types';

import CMSPage from './CMSPage.svelte';

export type CMSPageData = {
	identifier: string;
	title: string | null;
	meta_description: string | null;
	content: { type: 'html'; content: string };
};
export const cmsLoad = async ({ params, fetch, parent }: PageLoadEvent) => {
	const { store, title, metaDescription } = await parent();

	const urlParams = new URLSearchParams({ slug: params.slug });
	const response = await fetch(`/api/content/cms_page?${urlParams}`, {
		headers: {
			'X-Store-ID': store.store_id.toString(),
		},
	});
	if (response.status === 404) error(404);
	if (response.status !== 200) error(500);
	const pageData = (await response.json()) as CMSPageData;

	return {
		component: CMSPage,
		pageData: pageData,
		title: pageData.title || title,
		metaDescription: pageData.meta_description || metaDescription,
	};
};
